module.exports = __webpack_public_path__ + "img/home6Img1.fd73aad6.png";